(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initCaseExplorers = (scope = document) => {
    const explorers = scope.matches?.('[data-k9-case-explorer]')
      ? [scope]
      : [...scope.querySelectorAll('[data-k9-case-explorer]')];

    explorers.forEach((explorer) => {
      if (explorer.dataset.k9CaseReady) return;
      explorer.dataset.k9CaseReady = 'true';

      const hotspots = [...explorer.querySelectorAll('[data-k9-case-trigger]')];
      const details = [...explorer.querySelectorAll('[data-k9-case-detail]')];
      const defaultIndex = '6';
      let selectedIndex = defaultIndex;
      let committedIndex = defaultIndex;

      const showDetail = (index) => {
        selectedIndex = index;

        details.forEach((detail) => {
          const active = detail.dataset.k9CaseDetail === index;
          if (!active) {
            detail.hidden = true;
            detail.classList.remove('is-active');
            return;
          }

          detail.hidden = false;
          requestAnimationFrame(() => {
            if (selectedIndex === index) detail.classList.add('is-active');
          });
        });
      };

      const selectComponent = (index) => {
        committedIndex = index;
        showDetail(index);

        hotspots.forEach((hotspot) => {
          const active = hotspot.dataset.k9CaseTrigger === index;
          hotspot.classList.toggle('is-active', active);
          hotspot.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

      };

      hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', () => selectComponent(hotspot.dataset.k9CaseTrigger));
        hotspot.addEventListener('mouseenter', () => showDetail(hotspot.dataset.k9CaseTrigger));
        hotspot.addEventListener('mouseleave', () => showDetail(committedIndex));
      });

      selectComponent(defaultIndex);

      if (reducedMotion.matches || !hotspots.length || !('IntersectionObserver' in window)) return;

      const revealObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          explorer.classList.add('is-hotspots-revealed');
          revealObserver.unobserve(explorer);
          revealObserver.disconnect();
        },
        { threshold: 0.2 }
      );

      revealObserver.observe(explorer);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCaseExplorers(), { once: true });
  } else {
    initCaseExplorers();
  }

  document.addEventListener('shopify:section:load', (event) => initCaseExplorers(event.target));
})();
